import { render, staticRenderFns } from "./CecUnmUserSetsMealProject.vue?vue&type=template&id=3524a1a6&scoped=true"
import script from "./CecUnmUserSetsMealProject.vue?vue&type=script&lang=js"
export * from "./CecUnmUserSetsMealProject.vue?vue&type=script&lang=js"
import style0 from "./CecUnmUserSetsMealProject.vue?vue&type=style&index=0&id=3524a1a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524a1a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3524a1a6')) {
      api.createRecord('3524a1a6', component.options)
    } else {
      api.reload('3524a1a6', component.options)
    }
    module.hot.accept("./CecUnmUserSetsMealProject.vue?vue&type=template&id=3524a1a6&scoped=true", function () {
      api.rerender('3524a1a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cecunmusersetmeal/CecUnmUserSetsMealProject.vue"
export default component.exports